module.exports = __webpack_public_path__ + "img/mobile_map_cadiz.c4e88ee6.svg";